"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const emailSignIn_1 = require("./emailSignIn");
//import { goToURLRegexToyota, logoutURLRegexToyota, goToURLRegexLexus, logoutURLRegexLexus, goToURLRegexSAML, validHostnames, brandRegexMap } from './constants';
const constants_1 = require("./constants");
const axios_1 = require("axios");
//Last login attributes requires that source App be collected immediately on invocation of all 3 social trees
//This function agnostically gets and returns the sourceApp callback with the value substituted in properly
exports.getAndSubmitSourceAppCallback = (sourceApp, baseurl, realm, tree, name) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + "/" + name + "/json" + realm + "/authenticate";
    const headers = {
        "Accept-API-Version": "resource=2.0",
        "Content-Type": "application/json"
    };
    const params = {
        "authIndexType": "service",
        "authIndexValue": tree
    };
    return yield axios_1.default({
        headers,
        method: "post",
        params,
        url
    }).then(response => {
        if (response.data.callbacks) {
            response.data.callbacks[0].input[0].value = sourceApp;
        }
        return {
            response: response.data,
            status: response.status
        };
    })
        .catch(err => {
        return {
            response: err
        };
    });
});
// For any authentication that involves validating an OTP code, the initial AM authentication session is terminated because the OTP code is sent and validated through IDM.
// After the code is validated, a new authentication session is generated.
exports.finishPhoneAuthentication = (username, code, sourceApp, baseurl, name, realm) => __awaiter(void 0, void 0, void 0, function* () {
    //Call API to submit sourceApp
    const sourceAppCallBack = yield exports.getAndSubmitSourceAppCallback(sourceApp, baseurl, realm, "SessionValidation", name);
    return yield axios_1.default({
        data: sourceAppCallBack.response,
        url: baseurl + '/' + name + '/json/realms/root/realms' + realm + '/authenticate?authIndexType=service&authIndexValue=SessionValidation',
        method: 'post',
        headers: {
            'X-Username': username,
            'Accept-API-Version': 'resource=2.1,protocol=1.0',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${code}`
        }
    })
        .then((resp) => {
        // return resp, front end will call handleSuccess on it
        return {
            'code': 200,
            'resp': resp,
            'type': 'phoneAuth'
        };
    })
        .catch((err) => {
        // Set is response valid to false
        return {
            'code': 401,
            'resp': err,
            'state': {
                'isResponseValid': false,
                'loading': false
            }
        };
    });
});
// For phone OTP code authentication, the initial AM authentication session is terminated because the OTP code is sent and validated through IDM.
// If the user elects to sign in with password, a new authentication session is created.
exports.finishPasswordAuthentication = (username, sourceApp, baseURL, realm, tree, name, signInType) => __awaiter(void 0, void 0, void 0, function* () {
    let otpUsername = username;
    if (signInType === "OTP") {
        otpUsername = 'noverify-' + username;
    }
    const usernameResponse = yield emailSignIn_1.checkUsername(otpUsername, sourceApp, baseURL, realm, tree, name);
    if (usernameResponse.status > 199 && usernameResponse.status < 300) {
        return {
            'code': 200,
            'resp': usernameResponse,
            'type': 'passwordAuth'
        };
    }
    else {
        // set state loading false and responseValid false
        return {
            'code': 400,
            'resp': usernameResponse,
            'state': {
                'isResponseValid': false,
                'loading': false
            }
        };
    }
});
exports.validateSessionToken = (tokenId, baseurl, name, realm) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + "/" + name + "/json/realms/root/realms" + realm + "/sessions";
    const headers = {
        'Accept-API-Version': 'resource=2.1, protocol=1.0',
        'Content-Type': 'application/json',
        'iPlanetDirectoryPro': tokenId
    };
    const params = {
        '_action': 'validate',
    };
    return yield axios_1.default({
        headers,
        method: 'post',
        params,
        url
    }).then(response => {
        return {
            response: response.data,
            status: response.status
        };
    })
        .catch(err => {
        return {
            response: err.response.data,
            status: err.response.status
        };
    });
});
exports.validateUsers = (tokenId, baseurl, name, realm) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + "/" + name + "/json/realms/root/realms" + realm + "/users";
    const headers = {
        'Accept-API-Version': 'resource=2.1, protocol=1.0',
        'Content-Type': 'application/json',
        'iPlanetDirectoryPro': tokenId
    };
    const params = {
        '_action': 'idFromSession',
    };
    return yield axios_1.default({
        headers,
        method: 'post',
        params,
        url
    }).then(response => {
        return {
            response: response.data,
            status: response.status
        };
    })
        .catch(err => {
        return {
            response: err.response.data,
            status: err.response.status
        };
    });
});
exports.getSessionSAMLInfo = (tokenId, baseurl, name, realm) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + "/" + name + "/json/sessions";
    const headers = {
        'Accept-API-Version': 'resource=3',
        'Content-Type': 'application/json',
        'iPlanetDirectoryPro': tokenId
    };
    const params = {
        '_action': 'getSessionInfo',
    };
    return yield axios_1.default({
        headers,
        method: 'post',
        params,
        url
    }).then(response => {
        return {
            response: response.data,
            status: response.status
        };
    })
        .catch(err => {
        return {
            response: err.response.data,
            status: err.response.status
        };
    });
});
exports.getSessionInfo = (tokenId, baseurl, name, realm) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + "/" + name + "/json/realms/root/realms" + realm + "/sessions";
    const headers = {
        'Accept-API-Version': 'resource=3',
        'Content-Type': 'application/json',
        'iPlanetDirectoryPro': tokenId
    };
    const params = {
        '_action': 'getSessionInfo',
    };
    return yield axios_1.default({
        headers,
        method: 'post',
        params,
        url
    }).then(response => {
        return {
            response: response.data,
            status: response.status
        };
    })
        .catch(err => {
        return {
            response: err.response.data,
            status: err.response.status
        };
    });
});
exports.checkCookie = (baseurl, name, realm) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + "/" + name + "/json/realms/root/realms" + realm + "/sessions?_action=validate&refresh=false";
    const headers = {
        'Accept-API-Version': 'resource=2.1, protocol=1.0'
    };
    return yield axios_1.default({
        headers,
        method: 'post',
        url
    }).then(response => {
        if (!response || !response.data) {
            return {
                error: 'Validating session call returned an unexpected response.'
            };
        }
        else {
            return {
                valid: response.data.valid
            };
        }
    })
        .catch(err => {
        return {
            error: err
        };
    });
});
exports.logout = (baseurl, name, realm) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + "/" + name + "/json/realms/root/realms" + realm + "/sessions/?_action=logout";
    const headers = {
        'Accept-API-Version': 'resource=3.1,protocol=1.0',
    };
    return yield axios_1.default({
        headers,
        method: 'post',
        url
    }).then(response => {
        return {
            response: response.data
        };
    })
        .catch(err => {
        return {
            error: err,
        };
    });
});
// Checks if logout redirect uri is whitelisted
exports.isValidLogoutURL = (brand, logoutRedirectURL) => {
    var regexList;
    var whitelisted = false;
    if (brand === 'T') {
        regexList = constants_1.logoutURLRegexToyota;
    }
    else if (brand === 'L') {
        regexList = constants_1.logoutURLRegexLexus;
    }
    else {
        // Shouldn't happen because brand will always be passed in from the portal (Backlogged elegant error handling for dev mishaps)
        return null;
    }
    for (const i in regexList) {
        var regex = new RegExp(regexList[i]);
        if (regex.test(logoutRedirectURL)) {
            whitelisted = true;
            break;
        }
    }
    return whitelisted;
};
exports.processRedirectObject = (redirectObject) => {
    var redirectUrl = "";
    if (redirectObject.status < 299) {
        // Get social sign in redirect URL from response
        redirectUrl = redirectObject.response.callbacks[0].output[0].value;
    }
    return redirectUrl;
};
//Get AuthId from JSON. The AuthId keeps track of the authentication session.
exports.getAuthId = (redirectObject) => {
    var authId = "";
    if (redirectObject.status < 299) {
        authId = redirectObject.response.authId;
    }
    return authId;
};
//Get cookies set on browser
exports.getCookies = () => {
    return document.cookie;
};
//Set cookie on browser
exports.setCookies = (key, value, path, domain) => {
    document.cookie = key + "=" + value + ";path=" + path + ";domain=" + domain + ";secure";
};
// Determines if the goto redirect url cookie/queryParam is valid for login/registration
exports.isValidGoToURL = (brand, gotoURL) => {
    let decodedURL;
    try {
        decodedURL = decodeURIComponent(gotoURL); // Decode the entire URL
    }
    catch (e) {
        console.error("Error decoding the URL:", e);
        return false; // Return false if the URL decoding fails
    }
    let parsedURL;
    try {
        parsedURL = new URL(decodedURL); // Parse the decoded URL
    }
    catch (e) {
        console.error("Error parsing the decoded URL:", e);
        return false; // Return false if the URL is invalid
    }
    // Validate hostname (only accept trusted domains)
    if (!constants_1.validHostnames.includes(parsedURL.hostname)) {
        console.error("Invalid hostname:", parsedURL.hostname);
        return false; // Reject URLs with invalid domains
    }
    // Check if the brand is valid and get the corresponding regex
    const regex = constants_1.brandRegexMap[brand];
    if (!regex) {
        console.error("Invalid brand:", brand);
        return false; // Return false if the brand is invalid
    }
    // Check if the URL structure matches the brand-specific regex
    const isValidCoreStructure = regex.test(decodedURL);
    if (!isValidCoreStructure) {
        console.error("Invalid core URL structure for brand:", brand);
        return false; // Reject if core structure doesn't match
    }
    return true; // All validations passed
};
// Remove cookie on browser
exports.delCookies = (key, value, path, domain) => {
    document.cookie = key + "=" + value + ";path=" + path + ";domain=" + domain + ";max-age=0" + ";secure";
};
exports.redirect = (redirectUrl) => {
    window.location.replace(redirectUrl);
};
// Parse URL parameters
exports.parseURL = (url) => {
    const arr = url.replace("?", "").split("&");
    const params = {};
    for (var i = 0; i < arr.length; i++) {
        const pair = arr[i].split("=");
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
};
exports.getURLParams = () => {
    return window.location.search;
};
// Parse cookies on browser
exports.parseCookies = (cookies) => {
    const arr = cookies.replace(/\s+/g, "").split(";");
    const params = {};
    for (var i = 0; i < arr.length; i++) {
        const pair = arr[i].split(/=(.+)/);
        params[pair[0]] = pair[1];
    }
    return params;
};
